import type { Role } from '@shared/types/User';

/** Rôles attribuables via la matrice d’accès cabinet (jamais `super_admin`). */
export const CABINET_GRANTABLE_ROLES = ['admin', 'rh', 'comptable', 'lecture'] as const;

export type CabinetGrantableRole = (typeof CABINET_GRANTABLE_ROLES)[number];

export const CABINET_GRANTABLE_ROLE_LABELS: Readonly<Record<CabinetGrantableRole, string>> = {
  admin: 'Administrateur',
  rh: 'Gestionnaire RH',
  comptable: 'Comptable',
  lecture: 'Lecture seule',
};

export function isCabinetGrantableRole(role: Role): role is CabinetGrantableRole {
  return (CABINET_GRANTABLE_ROLES as readonly string[]).includes(role);
}

/** Rôle affiché / envoyé au sélecteur (repli sûr hors rôles attribuables). */
export function cabinetRoleForSelect(role: Role | null | undefined): CabinetGrantableRole {
  if (role && isCabinetGrantableRole(role)) return role;
  if (role === 'super_admin') return 'admin';
  return 'lecture';
}

export function cabinetGrantableRoleLabel(role: CabinetGrantableRole): string {
  return CABINET_GRANTABLE_ROLE_LABELS[role];
}
